export const FR = {
  "Open document": "Ouvrir le document",
  "Upload file": "TÃ©lÃ©verser un fichier",
  "Drop file here to upload": "DÃ©posez le fichier ici pour le tÃ©lÃ©charger",
  "Disc": "Disque",
  "URL": "URL",
  "FILE": "DÃPOSER",
  "SIZE": "TAILLE",
  "MB": "Mo",
  "KB": "Ko",
  "Bytes": "Octets",
  "Loading... Please wait.": "Chargement, veuillez patienter.",
  "Fit Width": "Ajuster la largeur",
  "Fit Height": "Hauteur d'ajustement",
  "Password protected document": "Document protÃ©gÃ© par mot de passe",
  "Password": "Mot de passe",
  "Open": "Ouvert",
  "Password Required": "Mot de passe requis",
  "Incorrect password": "Mot de passe incorrect",
  "Error": "Erreur",
  "Something went wrong": "Quelque chose s'est mal passÃ©",
  "Server is not available": "Le serveur n'est pas disponible",
  "of": "de",
  "Please wait...": "S'il vous plaÃ®t, attendez..."
};
